import React, { useEffect, useState } from 'react';
import { popupApi, EventPopup as Popup } from '../services/api/popupApi';
import { hidePopupToday, popupsToShow } from './eventPopupHide';
import EventPopupDialog from './EventPopupDialog';

// 첫 화면 팝업 — 관리자 「팝업 관리」에 올린 팝업 중 지금 기간 안이고 켜진 것을 순서대로 한 장씩 띄운다.
// 목록을 못 받아도 첫 화면은 그대로 둔다(팝업만 안 뜬다).
const EventPopup: React.FC = () => {
  const [queue, setQueue] = useState<Popup[]>([]);

  useEffect(() => {
    let alive = true;
    popupApi
      .listActive()
      .then((list) => {
        if (alive) setQueue(popupsToShow(list));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const current = queue[0];
  if (!current) return null;
  const next = () => setQueue((q) => q.slice(1));

  return (
    <EventPopupDialog
      key={current.id}
      popup={current}
      open
      onClose={next}
      onHideToday={() => {
        hidePopupToday(current.id);
        next();
      }}
    />
  );
};

export default EventPopup;
